const numberWithLetter = /[^\w]/gi;
const numberWithLine = /[^\d-,]/g;
const nomberOrRangeNumber = /((\d+|\d+-\d+)\b,*)+$/gy;

export default { numberWithLetter, numberWithLine, nomberOrRangeNumber };
